import React, { useRef } from "react";
import styles from "./index.module.scss";
import SectionTitle from "@src/components/SectionTitle";
import bg1 from "./assets/bg1.png";
import bg2 from "./assets/bg2.png";
import bg3 from "./assets/bg3.png";
import bg4 from "./assets/bg4.png";
import bg5 from "./assets/bg5.png";
import bg6 from "./assets/bg6.png";
import bg7 from "./assets/bg7.png";
import bg8 from "./assets/bg8.png";
import bg9 from "./assets/bg9.png";
import useFadeIn from "@src/hooks/useFadeIn";
// 1Brevis,2Phala,3Questflow,4Nillion,5Kite.ai,6Buzzing,7SatLayer,8EntertainM,9Pharos
// 1Pharos,2Brevis,3Nillion,4Phala,5Kite.ai,6Questflow,7SatLayer,8EntertainM,9Buzzing
const data = [
  {
    id: "9",
    title: "Pharos",
    content:
      "Primus’ pioneering zkTLS technology enables users to verify off-chain credentials, such as KYC, without disclosing sensitive personal information. The resulting zkDID framework will be natively integrated into Pharos’ ecosystem, providing a secure, compliant infrastructure optimized for RWA use cases.",
    bgUrl: bg9,
    link: "https://pharosnetwork.xyz",
  },
  {
    id: "1",
    title: <span>Brevis</span>,
    content:
      "Primus and Brevis together create a zk attestation framework which enables users to prove their both on-chain transactions and off-chain transactions in a privacy-preserving manner, and the relevant proofs are verifiable on-chain.",
    bgUrl: bg1,
    link: "https://brevis.network/",
  },
  {
    id: "4",
    title: "Nillion",
    content:
      "Primus and Nillion leverage zkTLS to enhance the integration of off-chain data with Web3 applications, ensuring both privacy and security. With Primus providing verified private data, the Nillion blind computation network enables further processing to meet diverse real-world application needs.",
    bgUrl: bg4,
    link: "https://nillion.com/",
  },
  {
    id: "2",
    title: "Phala",
    content:
      "By integrating Primus’s attestor service into Phala’s TEE, it’s ensured that there will be no party, even Primus itself, can tamper with the data verification process. The collaboration brings Primus zkTLS closer to security-critical scenarios such as decentralized finance and AI.",
    bgUrl: bg2,
    link: "https://phala.network/",
  },
  {
    id: "5",
    title: "Kite.ai",
    content:
      "Primus is bringing zkTLS to Kite AI, which makes HTTPS-based data provably verifiable on-chain. Primus is building the zkTLS verifier natively on Kite, enabling all AI dapps to verify the authenticity of any off-chain data through cryptographic proofs.",
    bgUrl: bg5,
    link: "https://gokite.ai/",
  },
  {
    id: "3",
    title: "Questflow",
    content:
      "Primus helps build a transparent proof-of-contribution of collaborative agents by enabling each agent to prove their activities with zkTLS. This ensures fair and automated compensation based on each agent’s contributions.",
    bgUrl: bg3,
    link: "https://questflow.ai/",
  },
  {
    id: "7",
    title: "SatLayer",
    content:
      "Primus is collaborating with SatLayer to bring private, offchain data onchain using zkTLS—enabling use cases like private credit and KYC-less DeFi.",
    bgUrl: bg7,
    link: "https://satlayer.xyz/",
  },
  {
    id: "8",
    title: "EntertainM",
    content:
      "Primus zkTLS solution enables EntertainM to verify users’ Twitch channel subscription status, allowing eligible users to participate in and benefit from the sentiment token trading market.",
    bgUrl: bg8,
    link: "https://www.entertainm.io/",
  },
  {
    id: "6",
    title: "Buzzing",
    content:
      "Primus uses zkTLS to ensure Buzzing AI agents access only authentic data sources and authorized LLM APIs. This reduces human intervention, lowers audit and trust management costs, prevents data manipulation, and boosts user trust through transparent, verifiable operations.",
    bgUrl: bg6,
    link: "https://www.buzzing.club/",
  },
];

const Card = ({ id, title, content, bgUrl, link }) => {
  const onJoin = (link) => {
    window.open(link);
  };
  return (
    <div className={styles.card}>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.content}>{content}</div>
          <a className={styles.btn} target="_blank" href={link}>
            <span>Visit</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
            >
              <path
                d="M8.16667 3.41797L12.25 7.5013M12.25 7.5013L8.16667 11.5846M12.25 7.5013L1.75 7.5013"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>
      <img alt="bg" className={styles.bg} src={bgUrl} />
    </div>
  );
};

export default () => {
  const ref = useRef();
  const [visible] = useFadeIn(ref);
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <SectionTitle
          transition
          ref={ref}
          visible={visible}
          className={styles.ecoSystemTitle}
        >
          Building with Primus
        </SectionTitle>
        <div className={styles.cardWrapper}>
          {data.map((item) => {
            return <Card key={item.title} {...item} />;
          })}
        </div>
      </div>
    </div>
  );
};
